import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  FETCH_ACC_CONTACTS_REQUEST,
  fetchAccountContactFailure,
  fetchAccountContactSuccess,
} from "../actions/accountContactsActions";
import { fetchAccountContacts } from "../../../services/accIqService";

// Worker Saga
function* fetchAccountContactDataSaga() {
  try {
    const payload = yield select(
      (state) => state?.accountContactsReducer?.payload
    );
    const data = yield call(fetchAccountContacts, payload);
    yield put(fetchAccountContactSuccess(data));
  } catch (error) {
    yield put(fetchAccountContactFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchAccountContactData() {
  yield takeLatest(FETCH_ACC_CONTACTS_REQUEST, fetchAccountContactDataSaga);
}
